import { Injectable, inject } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { TerminalNotificationRepository } from '@app/domain/ports/tpv/terminal-notification.repository';
import { TpvTerminalNotificationResult } from '@app/domain/models/tpv/terminal-notification.model';
import { NotifyTerminalRequest } from '@app/data/dtos/tpv/terminal-notification.dto';
import { tpvUrl } from '@app/data/tpv/tpv-api.config';
import { TpvEnvelope, unwrapTpv } from '@app/data/tpv/tpv-envelope';

/**
 * Reenvío de notificación/credenciales a una terminal
 * (`POST /terminals/<id_terminal>/notify/`, §6). `id_terminal` se percent-encodea
 * hacia la ruta. Auth y x-api-key vía interceptores estándar.
 */
@Injectable()
export class TerminalNotificationRemoteDataSource extends TerminalNotificationRepository {
  private readonly http = inject(HttpClient);

  override notify(
    idTerminal: string,
    request: NotifyTerminalRequest,
    idempotencyKey?: string,
  ): Observable<TpvTerminalNotificationResult> {
    let headers = new HttpHeaders({ 'Content-Type': 'application/json' });
    if (idempotencyKey) {
      headers = headers.set('Idempotency-Key', idempotencyKey);
    }
    return this.http
      .post<TpvEnvelope<unknown>>(
        tpvUrl(`terminals/${encodeURIComponent(idTerminal)}/notify/`),
        request,
        { headers },
      )
      .pipe(
        map((raw) => ({
          idTerminal,
          data: unwrapTpv<unknown>(raw),
        })),
      );
  }
}
